<template>
  <div class="support-page">
    <div class="support-page__panel" v-if="!dialog">
      <h1>Acionar suporte</h1>
      <p>
        Esta guia fica separada para que voce possa continuar navegando no
        sistema original e colar prints aqui quando necessario.
      </p>
      <v-btn text small @click="reopen">
        Reabrir atendimento
      </v-btn>
    </div>

    <SupportDialog
      v-if="ready"
      v-model="dialog"
      :origin="origin"
      :initial-context="context"
    />
  </div>
</template>

<script>
import SupportDialog from "../components/SupportDialog.vue";
import {
  buildSupportContext,
  readSupportContextSnapshot,
} from "../services/supportContext";

export default {
  name: "SupportPage",
  components: {
    SupportDialog,
  },
  data() {
    return {
      ready: false,
      dialog: true,
      context: null,
      origin: "area_logada",
    };
  },
  created() {
    const snapshot = readSupportContextSnapshot(this.$route.query.contextKey);

    if (snapshot && snapshot.contexto) {
      this.context = snapshot.contexto;
      this.origin = snapshot.origem || this.origin;
    } else {
      this.context = buildSupportContext(this, this.origin);
    }

    this.ready = true;
  },
  methods: {
    reopen() {
      this.dialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.support-page {
  align-items: center;
  background: #f3f4f6;
  display: flex;
  min-height: 100vh;
  padding: 32px 16px;
}

.support-page__panel {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin: 0 auto;
  max-width: 760px;
  padding: 24px;
  width: 100%;

  h1 {
    color: #111827;
    font-size: 24px;
    margin: 0 0 8px;
  }

  p {
    color: #4b5563;
    font-size: 14px;
    margin: 0;
  }
}
</style>
